import { render, staticRenderFns } from "./InstallmentPaymentPrice.vue?vue&type=template&id=bd8d583a&"
import script from "./InstallmentPaymentPrice.vue?vue&type=script&lang=js&"
export * from "./InstallmentPaymentPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports